import React from 'react';

import { StatusBadge } from '../../common/status-badge';

interface IActivityPropertyJobStatus {
  value?: string | null;
}

const getParsed = (raw: string | null | undefined) => {
  if (!raw) {
    return null;
  }
  return JSON.parse(raw) as IJobStatusType;
};

// ActivityProperty JobStatus = 13
export const ActivityPropertyJobStatusType = ({
  value,
}: IActivityPropertyJobStatus) => {
  const parsed = getParsed(value);

  return <StatusBadge colour={parsed?.Colour} label={parsed?.Name} />;
};

// a very cutdown version of what we care about from the serialized JSON. There's a bunch of other properties
// but this is all we care about for deserialisation
interface IJobStatusType {
  Colour?: string | null;
  Name?: string | null;
}
